export enum DocKind {
  ShareholdersAgreement1,
  ShareholdersAgreement2,
  ShareholdersAgreement3,
  TermSheet1,
  TermSheet2,
  Formalities,
  Wise,
  ArticlesOfAssoc,
  Qeso,
  Qbso,
  EmployeeWarrants,
  RedemptionOfWarrants,
  Advisors,
  HourlyWage,
  ManagingDirector,
  PermanentEmployment,
  OneWayNda,
  TwoWayNda,
  SubAgreement,
  InformationLetter,
  ConsultingAgreement,
  LoanAgreement,
  ConfirmationOfShareSubscription,
}
